import loadable from '@loadable/component'

export const EUUnsolicitedIssuers = loadable(
  () => import('./EUUnsolicitedIssuers')
)
export const IssuerEndorsementStatus = loadable(
  () => import('./IssuerEndorsementStatus')
)
export const NonParticipatingIssuers = loadable(
  () => import('./NonParticipatingIssuers')
)
export const UnsolicitedDisclosures = loadable(
  () => import('./UnsolicitedDisclosures')
)
export type { EUUnsolicitedIssuersProps } from './EUUnsolicitedIssuers'
export type { IssuerEndorsementProps } from './IssuerEndorsementStatus'
export type { NonParticipatingIssuersProps } from './NonParticipatingIssuers'
export type { UnsolicitedDisclosuresProps } from './UnsolicitedDisclosures'
